/* eslint-disable complexity */
import { Fragment } from "react";

import { css } from "@compiled/react";
import { useIntl, FormattedMessage } from "react-intl";

import { media } from "@atlaskit/primitives/responsive";
import { token } from "@atlaskit/tokens";

import { Button } from "@/components/wpl/button/src/button";
import { useLocalizedHref } from "@/libraries/web-framework/src/localization/use-localized-href";
import { DEFAULT_VALUES } from "@/libraries/web-framework/src/localization/values";

const jirafeatureHeroSectionStyle = css({
    display: "flex",
    maxWidth: "1200px",
    flexDirection: "column",
    margin: `${token("space.0")} auto ${token("space.0")} auto`
});

const heroSectionTextStyle = css({
    flex: "1",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    marginBlockStart: "15px",
    padding: `${token("space.400")} ${token("space.200")} ${token("space.0")}
        ${token("space.200")}`
});

const heroSectionTextStyleHeading = css({
    // eslint-disable-next-line local/ensure-wac-token-usage
    color: "#253858",
    letterSpacing: `${token("space.0")}`,
    margin: `${token("space.0")} ${token("space.0")} 24px ${token("space.0")}`,
    lineHeight: "1.25",
    fontWeight: "500",
    [media.below.sm]: {
        fontSize: `${token("space.400")}`
    },
    [media.above.sm]: {
        fontSize: `${token("space.600")}`
    }
});

const heroSectionTextStyleText = css({
    // eslint-disable-next-line local/ensure-wac-token-usage
    color: "#42526e",
    margin: `${token("space.0")} ${token("space.0")} ${token("space.300")}
    ${token("space.0")}`,
    fontSize: `${token("space.250")}`,
    lineHeight: "1.4",
    letterSpacing: "-.75px"
});

const heroSectionTextStyleButton = css({
    margin: `${token("space.0")} ${token("space.0")} ${token("space.300")}
    ${token("space.0")}`,
    fontWeight: "500"
});

const HeroSection = () => {
    const intl = useIntl();
    const getItFreeText = intl.formatMessage({
        id: "JiraFeatureSoftwarePageTemplate.heroCTA",
        defaultMessage: "Get it free"
    });

    return (
        <Fragment>
            <section>
                <div css={jirafeatureHeroSectionStyle}>
                    <div css={heroSectionTextStyle}>
                        <h1 css={heroSectionTextStyleHeading}>
                            <FormattedMessage
                                id="JiraFeatureSoftwarePageTemplate.heroHeader"
                                defaultMessage="Jira Software features"
                            />
                        </h1>
                        <p css={heroSectionTextStyleText}>
                            <FormattedMessage
                                id="JiraFeatureSoftwarePageTemplate.heroBody"
                                defaultMessage="How agile teams build and support world class software"
                                values={DEFAULT_VALUES}
                            />
                        </p>
                        <Button
                            text={getItFreeText}
                            aria-label={getItFreeText}
                            css={heroSectionTextStyleButton}
                            color="darkblue"
                            url={useLocalizedHref("/software/jira/free")}
                            dataEventProps={{
                                "data-product-key": "jiraSoftwareFeature",
                                "data-event-component": "linkButton",
                                "data-event-container": "heroSection",
                                "data-event": "clicked",
                                "data-label": getItFreeText
                            }}
                        />
                    </div>
                </div>
            </section>
        </Fragment>
    );
};

export default HeroSection;
